import { User as FirebaseUser } from "firebase/auth";
import { User } from "@/types/auth";

export function buildTempUser(firebaseUser: FirebaseUser, overrides?: Partial<User>): User {
  return {
    id: firebaseUser.uid,
    firebase_uid: firebaseUser.uid,
    email: firebaseUser.email || "",
    name: firebaseUser.displayName || "User",
    phone: firebaseUser.phoneNumber || undefined,
    avatar: firebaseUser.photoURL || undefined,
    isVerified: firebaseUser.emailVerified,
    createdAt: new Date(),
    updatedAt: new Date(),
    ...overrides,
  };
}
